/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import { NavBar } from "../NavBar";
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import Axios from "axios";
import { API_ROUTE, Routes} from "../../Helpers/Constants";
import AuthenticationContext from "../../Store/Authentication-Context";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderGif from "../../images/365 loading.gif";

const TermsAdmin = () => {
    const { setAuthContext } = useContext(AuthenticationContext);
    const urlParams = new URLSearchParams(window.location.search);
    const authContext = useContext(AuthenticationContext);
    const [addTerm, setAddTerm] = useState("");
    const [deleteConfirmPopUp, setDeleteConfirmPopUp] = useState(false);
    const [editTermPopup, setEditTermPopup] = useState(false);
    const [editInProgress, setEditInProgress] = useState(false);
    const [deleteTermDescription, setDeleteTermDescription] = useState("");
    const [rowData, setRowData] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState({
        termID: 0,
        termDescription: '',
        flag: true,
        sortOrder: 0
    });
    const [columnDefs, setColumnDefs] = useState();
    const [maxMinSort, setMaxMinSort] = useState({ maxSort: 0, minSort: 0 });
    const [loading, setLoading] = useState(true); 
    const [addTermDisable, setAddTermDisable] = useState(true);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: false,
    }), []);

    const handleDelete = async (params) => {
        try {
            let description = "";
            if (params.termDescription.length > 30) {
                description = params.termDescription.substring(0, 100) + "...";
            }
            else
                description = params.termDescription;
            setSelectedTerm(params);
            setDeleteConfirmPopUp(true);
            setDeleteTermDescription(description);
        } catch (error) {
            toast.error("Error deleting Term:", error);
        }
    };

    const editTerm = (params) =>
    {
        setEditInProgress(false);
        const updatedData = params.node.data;
        setSelectedTerm({
            termID: updatedData.termID,
            termDescription: updatedData.termDescription,
            flag: updatedData.flag,
            sortOrder: updatedData.sortOrder,
        });
        setEditTermPopup(true);
    }

    
    const onDescriptionChange = (event) => {
        setSelectedTerm({
            ...selectedTerm,
            termDescription: event.target.value,
        });
    };

    const handleEdit = async () => {
        setEditInProgress(true);
        const newRecord = {
            termID: selectedTerm.termID,
            termDescription: selectedTerm.termDescription,
            flag: selectedTerm.flag,
            sortOrder: selectedTerm.sortOrder,
        };
        await updateTerm(newRecord);
        FetchAllTerms();
        setEditTermPopup(false);
        toast.success("Term updated successfully");
    }

    const handleAddTerm = (event) => {
        const newTerm = event.target.parentElement.parentElement.querySelector('input[type="addterm"]').value;
        const newRecord = {
            termID: 0,
            termDescription: newTerm,
            flag: true,
            sortOrder: rowData.length === 0 ? 1 : maxMinSort.maxSort + 1,
        };
        addingTerm(newRecord);
    };

    const closeModal = (e) => {
        setDeleteConfirmPopUp(false);
    };

    const closeEditModal = (e) => {
        setEditTermPopup(false);
    };

    useEffect(() => {
        FetchAllTerms();
    }, []); 

    const handleCheckboxFlagChange = (field, params) => (e) => {
        const updatedData = { ...params.node.data };
        updatedData[field] = e.target.checked;
        updateTerm(updatedData);
    };

    useEffect(() => {
        let checkBlank = addTerm;
        if (checkBlank.trim() === "")
            setAddTermDisable(true);
        else
            setAddTermDisable(false);
    }, [addTerm]);

    const handleSwap = (params, type) => {
        const api = params.api;
        let currentRowNode = params.node; 
        let currentRowIndex = currentRowNode.rowIndex;
        let swapRowIndex = currentRowNode.rowIndex;
        if (type.toLowerCase() === "up") {
            swapRowIndex =currentRowIndex - 1
        }
        else {
            swapRowIndex = currentRowIndex + 1
        }
        const swapWithRowNode = api.getDisplayedRowAtIndex(swapRowIndex);

        if (swapWithRowNode) {

            let payload1 = {
                termID: currentRowNode.data.termID,
                termDescription: currentRowNode.data.termDescription,
                flag: currentRowNode.data.flag,
                sortOrder: swapWithRowNode.data.sortOrder,
            }
            let payload2 = {
                termID: swapWithRowNode.data.termID,
                termDescription: swapWithRowNode.data.termDescription,
                flag: swapWithRowNode.data.flag,
                sortOrder: currentRowNode.data.sortOrder,
            }
            updateTerm(payload1);
            updateTerm(payload2);
        } 
    };
    async function FetchAllTerms() {
        try {
            setLoading(true);
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const response = await Axios.get(API_ROUTE + Routes.GET_ALL_TERMS, config);
            if (response && response.data) {
                const responseData = JSON.parse(JSON.stringify(response.data));
                const data = responseData.map(item => ({
                    ...item,
                    tempTermID: item.termID,
                    tempTermDescription: item.termDescription,
                    tempFlag: item.flag,
                    tempSortOrder: item.sortOrder,
                }));
                const sortedData = data.sort((a, b) => a.sortOrder - b.sortOrder);
                setRowData(sortedData);
                setLoading(false);
                setAddTerm("");
                const sortOrders = responseData.map(term => term.sortOrder);
                setMaxMinSort(
                    {
                        maxSort: Math.max(...sortOrders),
                        minSort: Math.min(...sortOrders),
                    }
                );
            }

            setColumnDefs(
                [
                    { headerName: "Sort Order", field: "sortOrder", hide: true },
                    {
                        headerName: "S.No",
                        valueGetter: (params) => params.node.rowIndex + 1,  // Calculate serial number based on row index
                        width: 100,  // Set a fixed maxWidth for the serial number column
                        sortable: false,  // Disable sorting for this column
                        filter: false,
                        resizable: false,
                    },
                    {
                        headerName: "Terms",
                        field: "termDescription", flex: 1,
                        minWidth: 1200,
                        resizable: false,
                        cellRenderer: (params) => {
                            const description = params.value || "No description available";
                            return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <button
                                        onClick={() => editTerm(params)}
                                        className="btn btn-sm"
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "blue",
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                        </svg>
                                    </button>

                                    <div title={description}>
                                        {description}
                                    </div>
                                </div>
                            );
                        }
                    },
                    {
                        headerName: "Sorting",
                        field: "actions",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        sortable: false,
                        //cellStyle: { 'text-align': 'center' },
                        cellRenderer: (params) => {
                            const isFirstRow = params.node.rowIndex === 0;
                            const isLastRow = params.node.rowIndex === params.api.getDisplayedRowCount() - 1;

                            return (<div>
                                {!isFirstRow && < button
                                    onClick={() => handleSwap(params, "up")}
                                    className="btn btn-sm"
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "blue",
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5" />
                                    </svg>
                                </button>}
                                {!isLastRow && <button
                                    onClick={() => handleSwap(params, "down")}
                                    className="btn btn-sm"
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "blue",
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
                                    </svg>
                                </button>}
                            </div>)
                        },
                        flex: 1,
                        width: 150,
                        resizable: false
                    },
                    {
                        headerName: "Enabled",
                        field: "flag",
                        headerStyle: { textAlign: "center", fontWeight: "bold" },
                        headerComponentParams: {
                            style: { display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" },
                        },
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => (
                            <input
                                type="checkbox"
                                checked={params.value || false}
                                onChange={handleCheckboxFlagChange("flag".toLowerCase(), params)}
                                style={{
                                    cursor: "pointer",
                                    accentColor: "rgb(81, 145, 206)",
                                }}
                            />
                        ),
                        flex: 1,
                        width: 150,
                        resizable: false
                    },
                    {
                        headerName: "Options",
                        field: "actions",
                        headerStyle: { textAlign: "right", fontWeight: "bold" },
                        flex: 1,
                        width: 150,
                        resizable: false,
                        //cellStyle: { textAlign: "center" },
                        cellRenderer: (params) => {

                            return <div>
                                    <button
                                        onClick={() => handleDelete(params.data)}
                                        className="btn btn-danger btn-sm"
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "red"
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="rgb(81, 145, 206)" className="bi bi-trash" viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                    </button>
                                </div>
                        }
                    }
                ]
            );
            
        } catch (error) {
            console.error("Error occurred while fetching Terms", error);
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    async function addingTerm(payload) {
        try {
            setAddTermDisable(true);

            const tokenString = await setAuthContext("", new Date());
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const data = {
                termID: 1,
                termDescription: addTerm,
                flag: true,
                sortOrder: payload.sortOrder,
                orgId: orgId
            }

            const response = await Axios.post(API_ROUTE + Routes.ADD_TERM, data, config);

            if (response && response.data) {
                FetchAllTerms()
                toast.success("Term Added successfully", response.data);
            }
            setAddTermDisable(false);
        } catch (error) {
            toast.error("Error occurred while adding Term");
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    async function deleteTerm() {
        try {
            const termID = selectedTerm.termID;
            const tokenString = await setAuthContext("", new Date());
            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            const response = await Axios.get(API_ROUTE + Routes.GET_DELETE_TERM + `/` + termID, config);
            if (response && response.data) {
                toast.success("Deleted successfully");
            }
            setDeleteConfirmPopUp(false);
            FetchAllTerms();
        } catch (error) {
            toast.error("Error occurred while deleting Term");
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }
    async function updateTerm(payload) {
        try {

            const tokenString = await setAuthContext("", new Date());

            let config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            const response = await Axios.post(API_ROUTE + Routes.GET_UPDATE_TERM, payload, config);

            if (response && response.data) {
                FetchAllTerms();
                return response.data
            }
        } catch (error) {
            console.error("Error occurred while update Term:", error);
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        }
    }

    const addTermChange = (event) => {
        const updatedTerm = event.target.parentElement.parentElement.querySelector('input[type="addterm"]').value;
        let checkBlank = updatedTerm;
        if (checkBlank.trim() === "")
            setAddTermDisable(true);
        else
            setAddTermDisable(false);
        setAddTerm(updatedTerm);
    };

    return (
        <Container width='100%' id="setting_container">
            <NavBar page="termsadmin" authContext={authContext} />
            <div className="ms-2 SectionTitle" style={{
                fontSize: '2vw',
                fontWeight: '500'
            }} >
                Contract Terms
            </div>
            <div style={{ padding: "0px 5px 0px 5px" }}>
                <Form.Group controlId="restoreReason">
                    <InputGroup className="mb-3">
                        <Form.Control
                            type="addterm" placeholder="Enter Term Description" onChange={addTermChange} value={addTerm}
                        />
                        <Button variant="primary" onClick={handleAddTerm} disabled={addTermDisable}>Add New Term</Button>
                    </InputGroup>
                    <div className="ag-theme-alpine" style={{ height: "750px", overflow: "auto" }}>
                        {loading ? (  // Show loader while data is loading
                            <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
                                <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                            </div>
                        ) : (
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            domLayout="autoHeight"
                            />
                        )}
                    </div>
                </Form.Group>
            </div>
            <Modal
                show={deleteConfirmPopUp}
                onHide={closeModal}
                centered
                size="lg"
            >
                <Modal.Header style={{ padding: 0 }}>
                    <Modal.Title id="exampleModalLabel" style={{ textAlign: "left", width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: "10px" }}>DELETE TERM</h3>
                            <button type="button" className="btn-close" aria-label="Close" style={{ transform: 'scale(0.75)', marginRight: "5px" }} onClick={closeModal}></button>
                        </div>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<hr style={{ borderTop: "1px solid #2671bfcc", margin: "10epx 0" }} />*/}
                    <h5 style={{ margin: "10px" }}>
                        Are you sure you want to delete the term "
                        {deleteTermDescription }
                        "?
                    </h5>
                    {false && <div style={{ position: 'absolute', height: '100%', width: '96%', background: 'white', top: '0px', opacity: '0.8' }}>
                        <div className="justify-content-center align-items-center d-flex h-100" >
                            <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                        </div>
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={deleteTerm} >
                        Confirm
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setDeleteConfirmPopUp(false);
                        FetchAllTerms();
                    }} >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                id="editTerm"
                show={editTermPopup}
                onHide={closeEditModal}
                centered
                size="lg"
                backdrop="static"
            >
                <Modal.Header style={{ padding: 0 }}>
                    <Modal.Title id="exampleModalLabel" style={{ textAlign: "left", width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: "10px" }}>Edit Term Description</h3>
                            <button type="button" className="btn-close" aria-label="Close" style={{ transform: 'scale(0.75)', marginRight: "5px" }} onClick={closeEditModal}></button>
                        </div>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editInProgress && <div style={{ position: 'absolute', height: '100%', width: '96%', background: 'white', top: '0px', opacity: '0.8' }}>
                        <div className="justify-content-center align-items-center d-flex h-100" >
                            <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                        </div>
                    </div>}
                    <div style={{ padding: "0px 5px 0px 5px" }}>
                        <Form.Group controlId="restoreReason">
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={selectedTerm.termDescription}
                                onChange={onDescriptionChange}
                                placeholder="Enter text..."
                                style={{
                                    borderColor: 'black',
                                    borderStyle: 'solid',
                                    padding: '10px',
                                    fontSize: '16px',
                                    height: '170px',
                                    width: '100%'
                                }}
                            />
                        </Form.Group>
                    </div>
                </Modal.Body>


                <Modal.Footer>
                    <Button variant="secondary" onClick={closeEditModal} disabled={editInProgress} >
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => handleEdit()} disabled={!selectedTerm.termDescription.trim() || editInProgress}>
                        Update Term
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    );
}
export default TermsAdmin;


